/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ApplicationSourcesControllerRemoveMutationResponse, ApplicationSourcesControllerRemovePathParams, ApplicationSourcesControllerRemove401, ApplicationSourcesControllerRemove403, ApplicationSourcesControllerRemove404 } from "../../models/checklistsController/ApplicationSourcesControllerRemove";

function getApplicationSourcesControllerRemoveUrl(id: ApplicationSourcesControllerRemovePathParams["id"]) {
  const res = { method: 'DELETE', url: `/api/v1/checklist-application-sources/${id}` as const }  
  return res
}

/**
 * @summary Delete a checklist application source (soft delete)
 * {@link /api/v1/checklist-application-sources/:id}
 */
export async function applicationSourcesControllerRemove(id: ApplicationSourcesControllerRemovePathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ApplicationSourcesControllerRemoveMutationResponse, ResponseErrorConfig<ApplicationSourcesControllerRemove401 | ApplicationSourcesControllerRemove403 | ApplicationSourcesControllerRemove404>, unknown>({ method : "DELETE", url : getApplicationSourcesControllerRemoveUrl(id).url.toString(), ... requestConfig })  
  return res.data
}